import { useState } from 'react'

const useCurrentIndex = () => {
  const [currentIndex, setCurrentIndex] = useState(0)

  return { currentIndex, setCurrentIndex }
}

export { useCurrentIndex }

export const resizeImageDisplay = (containerSize?: number) => {
  if (!containerSize) return { width: '8rem', height: '8rem' }

  if (containerSize <= 768 && window.matchMedia('(pointer: coarse)').matches) {
    return { width: `${containerSize}px`, height: `${containerSize}px` }
  }

  const imageSize = containerSize ? Math.round(containerSize / 6) : '4rem'
  return { width: `${imageSize}px`, height: `${imageSize}px` }
}

export const isMobile = () => {
  return window.matchMedia('(max-width: 768px)').matches
}

export const setLocalItem = (key: string, item: string) =>
  localStorage.setItem(key, item)
export const getLocalItem = (key: string) => localStorage.getItem(key)
